import { api, sp } from "./_base";


export const getAllAlloyConfigs = async (schemaName = null) => {
  try {
    const response = await api.get("/alloy-configs/", { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error fetching alloy configs:", error);
    throw error;
  }
};

export const getAlloyConfigsWithPagination = async (params = {}) => {
  try {
    const response = await api.get("/alloy-configs/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching alloy configs:", error);
    throw error;
  }
};

export const getAlloyConfigById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-configs/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error fetching alloy config:", error);
    throw error;
  }
};

export const createAlloyConfig = async (data, schemaName = null) => {
  try {
    const response = await api.post("/alloy-configs/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error creating alloy config:", error);
    throw error;
  }
};

export const updateAlloyConfig = async (id, data, schemaName = null) => {
  try {
    const response = await api.put(`/alloy-configs/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating alloy config:", error);
    throw error;
  }
};

export const deleteAlloyConfig = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/alloy-configs/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error deleting alloy config:", error);
    throw error;
  }
};

export const approveAlloyConfig = async (id, schemaName = null) => {
  try {
    const response = await api.post(`/alloy-configs/${id}/approve/`, {}, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error approving alloy config:", error);
    throw error;
  }
};

export const denyAlloyConfig = async (id, schemaName = null) => {
  try {
    const response = await api.post(`/alloy-configs/${id}/deny/`, {}, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error denying alloy config:", error);
    throw error;
  }
};

export const bulkDeleteAlloyConfigs = async (ids, schemaName = null) => {
  try {
    const deletePromises = ids.map(id => deleteAlloyConfig(id, schemaName));
    return await Promise.all(deletePromises);
  } catch (error) {
    console.error("Error bulk deleting alloy configs:", error);
    throw error;
  }
};
